import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getExportChargeInstanceDebtors = async ({
    token,
    charge_instance_id,
}) => {

    const params = {
        charge_instance_id
    }

    try {
        const res = await axiosCreate.get('/charge/instance/debtor/export', {
            responseType: 'blob',
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        //Blob de tipo xlsx, es decir excel
        const blobFile = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

        return blobFile;
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}